import { api } from "@/services/api"
import { queryClient } from "@/queryClient"

export type CreateCustomerRequest = {
  name: string
  email: string | null
  phone: string | null
}

export const createCustomer = async (
  params: CreateCustomerRequest
) => {
  await api.post("/services/customers/", { body: params })

  queryClient.invalidateQueries([CUSTOMERS_QUERY_KEY])
}
